// extracted by mini-css-extract-plugin
export default {"wrapper":"ValidityPeriodButtons_wrapper__Gt2sQ","formLabel":"ValidityPeriodButtons_formLabel__2eTvK"};